import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type CheckForDuplicateAccountsQueryVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CheckForDuplicateAccountsInput;
}>;

export type CheckForDuplicateAccountsQueryResult = { __typename?: 'Query' } & {
  checkForDuplicateAccounts?: GraphQLTypes.Maybe<
    { __typename?: 'CheckForDuplicateAccountsPayload' } & {
      errors: Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>;
      possibleDuplicates: Array<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'tradingName'>>;
    }
  >;
};

export const CheckForDuplicateAccountsDocument = gql`
  query checkForDuplicateAccounts($input: CheckForDuplicateAccountsInput!) {
    checkForDuplicateAccounts(input: $input) {
      errors {
        message
        path
      }
      possibleDuplicates {
        id
        tradingName
      }
    }
  }
`;
